"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceConfigSchema = exports.CalculationSourceConfigSchema = exports.Calculation = exports.Value = void 0;
const _imports_1 = require("../_imports");
const _shared_1 = require("../_shared");
// Re-export nested namespaces
exports.Value = __importStar(require("./Value"));
exports.Calculation = __importStar(require("./Calculation"));
// Re-export Calculation.SourceConfigSchema for backward compatibility
var Calculation_1 = require("./Calculation");
Object.defineProperty(exports, "CalculationSourceConfigSchema", { enumerable: true, get: function () { return Calculation_1.SourceConfigSchema; } });
// Import for local use
const Value = __importStar(require("./Value"));
const Calculation = __importStar(require("./Calculation"));
// ============= ZOD SCHEMAS =============
// WaiveConfig schema
const WaiveConfigSchema = _imports_1.z.object({
    reason: _imports_1.z.string(),
    config: _shared_1.FormulaConfigSchema,
});
// ConcentrationLimit.SourceConfig schema
exports.SourceConfigSchema = _imports_1.z.object({
    propertyKey: _imports_1.z.string(),
    waiveConfigs: _imports_1.z.array(WaiveConfigSchema),
    calculationConfig: Calculation.SourceConfigSchema.optional(),
    valueConfig: Value.ConfigSchema,
});
//# sourceMappingURL=index.js.map